/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles.css';

import NavBar from '../../components/NavBar';
import Load from '../../components/Load';

import { getToken } from '../../api/auth';
import calendarUSAMask from '../../utils/masks/calendarUSAMask';

import { CropsFetch } from '../../api/services/NotebookAPI';

export default function Crop({ history }) {
  const token = getToken();
  const [crops, setCrops] = useState([]);
  const [messageWarning, setMessageWarning] = useState('');
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function getCrops() {
      setIsLoad(true);
      try {
        const resultCrops = await CropsFetch(token);
        console.log('getCrops | resultCrops: ', resultCrops);
        setIsLoad(false);
        setMessageWarning(resultCrops.message);
        setIsSuccessMessage(resultCrops.isSuccess);
        if (resultCrops.isSuccess) {
          setCrops(resultCrops.crops);
        }
      } catch (error) {
        console.log('getCrops | error: ', error);
        setIsSuccessMessage(false);
        setMessageWarning('No momento esse recurso está indisponível, tente novamente mais tarde.');
        setIsLoad(false);
      }
    }

    getCrops();
  }, [history, token]);

  return (
    <>
      <Load isShow={isLoad} />
      <NavBar navigation={history} />
      <div className="container__above_header">
        <div className="form">
          <p className="form__description">
            Histórico de Colheitas
          </p>

          {messageWarning && <p className={isSuccessMessage ? 'form__message form__message--success' : 'form__message form__message--error'}>{messageWarning}</p>}

          <button
            className="form__button"
            type="button"
            // eslint-disable-next-line no-undef
            onClick={() => navigate('/notebook/crop/create', { replace: true })}
          >
            Registrar Colheita
          </button>

          {crops.map((crop) => (
            <div
              className="detail__container"
              onClick={() => navigate(`/notebook/crop/${crop.id}`, { replace: true })}
              aria-hidden="true"
            >
              <p className="detail__value">
                {(crop.feedstock).toUpperCase()}
              </p>
              <p className="detail__value">
                {calendarUSAMask(crop.created)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
